import { Modal } from 'antd';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setModalState } from '../../../../../../reducers/Modal/actions';
import { MODAL_CREATE_ENTITY } from '../../../../../../reducers/Modal/types';
import { ZorbaInput, ZorbaButton } from '../../../../../../components/forms';
import { BUTTON_VARIANT_DARK } from '../../../../../../components/forms/ZorbaButton/constants';
import { postRequest } from '../../../../../../services/requestService';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../../../../services/notificationsService';
import { fetchEntitites } from '../../../../../../reducers/Entities/actions';

import './index.scss';

export const CreateEntityModal = ({ entity }) => {
  const { isCreateEntityModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const dispatch = useDispatch();
  const [entityName, setEntityName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (entity) {
      setEntityName(entity);
    }
  }, [entity]);

  const handleCloseModal = () => {
    setEntityName('');
    dispatch(setModalState(MODAL_CREATE_ENTITY, false));
  };

  const handleCreateEntity = async () => {
    try {
      setIsLoading(true);
      await postRequest('/buyers/entities/create-entity', {
        entityName: entityName.trim().toUpperCase(),
      });
      setIsLoading(false);
      dispatch(fetchEntitites());
      handleCloseModal();
      showSuccessToast('Entity created successfully');
    } catch (error) {
      showErrorToast(error.response?.data?.reason || 'Creating entity failed!');
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={isCreateEntityModalOpen}
      footer={null}
      onCancel={handleCloseModal}
      title="Add new entity to your organization"
      className="create-entity-modal"
      destroyOnClose
    >
      <div className="input-container">
        <ZorbaInput
          placeholder="Entity name"
          onChange={(e) => setEntityName(e.target.value)}
          value={entityName}
        />
      </div>
      <div className="create-button-container">
        <ZorbaButton
          fullWidth={false}
          variant={BUTTON_VARIANT_DARK}
          onClick={handleCreateEntity}
          disabled={entityName.length <= 2 || isLoading}
          loading={isLoading}
        >
          Add
        </ZorbaButton>
      </div>
    </Modal>
  );
};
